import { useTranslation } from 'react-i18next';
import type { ClientAnnouncement } from '@/api/announcements/announcementsApi.types';
import { AnnouncementItem } from '@/components/client/AnnouncementsPage/AnnouncementItem';
import { Card } from '@/components/ui/card';
import { useAnnouncementSenderName } from '@/hooks/useAnnouncementSenderName';

interface ComposeBroadcastPreviewProps {
  title: string;
  body: string;
}

export function ComposeBroadcastPreview({ title, body }: ComposeBroadcastPreviewProps) {
  const { t } = useTranslation('broadcasts');
  const senderName = useAnnouncementSenderName();
  const trimmedTitle = title.trim();
  const trimmedBody = body.trim();
  const previewAnnouncement: ClientAnnouncement = {
    id: 'compose-preview',
    title: trimmedTitle.length > 0 ? trimmedTitle : t('compose.previewEmptyTitle'),
    body: trimmedBody.length > 0 ? trimmedBody : t('compose.previewEmptyBody'),
    publishedAt: new Date().toISOString(),
  };
  const emailSubjectPreview =
    trimmedTitle.length > 0 ? trimmedTitle : t('compose.previewEmptyTitle');

  return (
    <Card padding="lg" className="space-y-4">
      <h2 className="text-sm font-bold text-zooindigo">{t('compose.previewHeading')}</h2>
      <div className="space-y-1.5">
        <p className="text-[11px] font-bold uppercase tracking-wider text-zoomuted">
          {t('compose.previewInAppLabel')}
        </p>
        <div className="rounded-2xl border border-zooborder px-3 bg-zoooffwhite">
          <AnnouncementItem announcement={previewAnnouncement} senderName={senderName} />
        </div>
      </div>
      <div className="space-y-1.5">
        <p className="text-[11px] font-bold uppercase tracking-wider text-zoomuted">
          {t('compose.previewEmailLabel')}
        </p>
        <p className="text-sm font-medium text-zooindigo rounded-xl border border-zooborder px-3 py-2">
          {emailSubjectPreview}
        </p>
      </div>
    </Card>
  );
}
